import { TmcContextService } from './../../../../common/tmc-context.service';
import { RegistrationStepperModel } from './../../model/registration-step-model';
import { TransportRegistration } from './../../model/transport-registration';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';

import { AsyncSubject, Subscription } from 'rxjs';
import { RegistrationTransportOption } from '../../model/registration-transport-option';
import { AppClientConfigurationService } from '@sdbn/common';
import { TransportOption, TransportOptionColumn, TransportOptionSelection, TransportOptionsPanelModel } from '../../../../components/transport-options-panel/transport-options-panel.model';
import { YardConfiguration } from '../../../../client/model/yard-configuration';
import { TransportOptionParameterValue } from '../../../../client/model/transport-option';

@Component({
    selector: 'app-transport-options',
    templateUrl: './transport-options.component.html',
    styleUrls: ['./transport-options.component.scss'],
    standalone: false
})
export class TransportOptionsComponent implements OnInit, AfterViewInit {

  private stepCompleted = false;
  _registration: TransportRegistration;

  model: TransportOptionsPanelModel;
  validStateSubscription: Subscription;
  selectionChangeSubscription: Subscription;

  tmcContextSubscription: Subscription;
  yardConfiguration: YardConfiguration;

  @Input() set registration(registration: TransportRegistration) {
    this._registration = registration;
    this.createTransportOptionsModel();
  }

  @Input() stepperModel: RegistrationStepperModel;

  constructor(
    public cps: AppClientConfigurationService,
    private tmcContextService: TmcContextService
  ) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.stepperModel.stepCompleted = () => {
      return this.stepCompleted;
    };

    this.stepperModel.beforeShowNextStep = () => {
      const subject = new AsyncSubject<boolean>();
      subject.next(true);
      subject.complete();
      return subject;
    };
  }

  createTransportOptionsModel() {

    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
    }

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        this.yardConfiguration = next;
        let columns = new Array<TransportOptionColumn>();
        for (let option of this.yardConfiguration.transportOptions) {
          while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
            let column = new TransportOptionColumn();
            columns.push(column);
          }
          let column = columns[option.columnIndex];
          column.options.push(new TransportOption(option));
        }

        const selection = new Array<TransportOptionSelection>();
        for (const option of this._registration.selectedOptions) {
          const newOption = new TransportOptionSelection(option);
          if (option.selectedParameterValues != null) {
            for (const value of option.selectedParameterValues) {
              // TODO Models für Transportoptionen verallgemeinern
              newOption.parameterValues.push(new TransportOptionParameterValue({
                id: value,
                valueDictionaryKey: 'dd.TRANSPORT_OPTION_PARAMETER_VALUE.' + value + '.VALUE'
              }));
            }
          }
          newOption.transportOptionId = option.id;
          newOption.selected = true;
          selection.push(newOption);
        }

        this.model = new TransportOptionsPanelModel({ columns: columns, constraints: this.yardConfiguration.transportOptionConstraints, selection: selection });
        this.validStateSubscription = this.model.validState.subscribe(bool => {
          this.stepCompleted = bool;
        });

        this.selectionChangeSubscription = this.model.selectionChange.subscribe(() => {

          const newSelection = new Array<RegistrationTransportOption>();
          for (const selection of this.model.getOnlySelectedTransportOptionSelection()) {
            if (selection.selected) {
              // TODO Models für Transportoptionen verallgemeinern
              const selectedOption = new RegistrationTransportOption({});
              selectedOption.id = selection.transportOptionId;
              selectedOption.amountOfPallettes = selection.amountOfPallettes;
              selectedOption.amountOfBoxes = selection.amountOfBoxes;
              selectedOption.amountInKilogramm = selection.amountInKilogramm;
              selectedOption.amountInLiter = selection.amountInLiter;
              selectedOption.amountOthers = selection.amountOthers;

              if (selection.parameterValues != null) {
                for (const value of selection.parameterValues) {
                  selectedOption.selectedParameterValues.push(value.id);
                }
              }

              newSelection.push(selectedOption);
            }
          }
          this._registration.selectedOptions = newSelection;
        });
      }
    });
  }

}
